import React, { useEffect, useState } from 'react';
import Modal from './Modal';
import axios from 'axios';
import { toast } from 'react-toastify';
import { faPencil } from '@fortawesome/free-solid-svg-icons';
import Button from '../Form/Button';

import './CreateProductModal.scss';
import { API_BASE_URL } from '../../api';

export default function EditBatchModal({ show, onClose, batch, onSuccess }) {
  const [batchNumber, setBatchNumber] = useState('');
  const [expirationDate, setExpirationDate] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (batch) {
      setBatchNumber(batch.batchNumber ?? '');
      setExpirationDate(batch.expirationDate ? batch.expirationDate.substring(0, 7) : '');
    }
  }, [batch]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.patch(
        `${API_BASE_URL}/api/v1/stock/batches/${batch.id}`,
        {
          batchNumber: batchNumber || null,
          expirationDate: expirationDate ? `${expirationDate}-01` : null,
        },
        { withCredentials: true }
      );
      toast.success('Lot mis à jour avec succès');
      onSuccess?.();
      onClose();
    } catch (err) {
      toast.error('Erreur lors de la mise à jour du lot');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      id="editBatchModal"
      classSize="modal-sm"
      title="Modifier le lot"
      show={show}
      onClose={onClose}
      icon={faPencil}
      iconBg="#eff6ff"
      iconColor="#2563eb"
      footer={
        <div style={{ display: 'flex', gap: 8, width: '100%' }}>
          <button type="button" className="btn btn-light btn-sm" onClick={onClose} style={{ flex: 1 }}>
            Annuler
          </button>
          <Button
            isLoading={loading}
            loadingMessage="Enregistrement…"
            className="btn btn-primary btn-sm"
            type="submit"
            form="editBatchForm"
            style={{ flex: 2, fontWeight: 600 }}
          >
            Enregistrer
          </Button>
        </div>
      }
    >
      <form id="editBatchForm" onSubmit={handleSubmit}>
        <div className="cdm-section">
          <p className="cdm-section__label">Informations du lot</p>

          <div className="mb-3">
            <label className="cdm-field-label">Date d'expiration <span className="text-danger">*</span></label>
            <input
              type="month"
              className="form-control form-control-sm"
              value={expirationDate}
              onChange={e => setExpirationDate(e.target.value)}
              required
            />
          </div>
          <div>
            <label className="cdm-field-label">
              Numéro de lot
              <span style={{ fontSize: 11, fontWeight: 400, color: '#9ca3af', marginLeft: 6 }}>optionnel</span>
            </label>
            <input
              type="text"
              className="form-control form-control-sm"
              value={batchNumber}
              onChange={e => setBatchNumber(e.target.value)}
              placeholder="Ex: SNAP-B5929973"
            />
          </div>
        </div>
      </form>
    </Modal>
  );
}
